import { atom } from 'recoil'

// dependency update
export const userLogInfoJoinState = atom({
	key: "userLogInfoJoinState",
	default: {}
})
